import { render } from "./LoansTable.vue?vue&type=template&id=bb754104"
import script from "./LoansTable.vue?vue&type=script&lang=js"
export * from "./LoansTable.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__